<template>
  <v-container class="categories" fluid v-if="!Istrue">
    <v-row
        align="center"
        justify="center"
        v-for="(Baseitem, index) in AllCat"
        :key="index"
    >
      <v-col cols="8">
        <div class="lists-show-products">
          <div class="items-show-cat-category">
            <div
                class="itemproduct_cat-category"
                v-for="(item, index) in Baseitem.products"
                :key="index"
            >
              <div class="add-to-cart_cats" v-if="item.product_discount > 0">
                <div class="itemscategory">
                  <p>{{ item.product_discount }}%</p>
                </div>
              </div>
              <router-link role="button"
                           :to="{ name: 'single', query: { id: item.product_id } }"
              >
                <div class="img-itemproduct_cat-category mb-2 mrx-auto mlx-auto">
                  <img class="mrx-auto mlx-auto" alt="" :src="item.product_icon"/>
                </div>
                <div class="text-itemproduct_cat-category">
                  <h6 class="multi-line text-center" style="text-align: center !important;">{{ oracle.product_title(item) }}</h6>
                  <span class="font-weight-bold text-center" style="text-align: center !important;">{{ oracle.format(item.product_sell_price) }} {{oracle.translate('تومان')}}</span>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="8">
        <div
            class="title-show-products-category"
            v-ripple role="button" @click="GetOnPro(Baseitem.category_id, oracle.category_name(Baseitem))"
        >
          <span style="color: white">{{oracle.translate('انواع')}} <b>{{ oracle.category_name(Baseitem) }}</b> </span>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import oracle from "@/oracle";

export default {
  name: "products",
  data: () => ({
    dataProducts: [
      {id: "0", count: 0},
      {id: "1", count: 1},
      {id: "2", count: 2},
      {id: "3", count: 3},
    ],
    page: 1,
    empty: false,
    Istrue: true,
    oracle: oracle,
    AllCat: [],
  }),
  methods: {
    plus(id) {
      this.dataProducts.forEach((item) => {
        if (item.id === id) item.count += 1;
      });
    },
    minus(id) {
      this.dataProducts.forEach((item) => {
        if (item.id === id) item.count -= 1;
      });
    },
    GetCat(response) {
      for (let i = 0; i < response.data.length; i++) {
        response.data[i].products = [];
      }
      this.AllCat = response.data;
      for (let i = 0; i < this.AllCat.length; i++) {
        oracle.axios(
            "product/getList",
            {
              offset_by: 0,
              limit_by: 4,
              order_by: "priority",
              parent_by: this.AllCat[i].category_id,
            },
            this.GetSubCat,
            null,
            null,
            this.AllCat[i]
        );
      }
    },
    GetSubCat(response, category) {
      category.products = response.data;
      this.Istrue = true;
      this.Istrue = false;
    },
    GetOnPro(id, name) {
      this.$router.push({
        name: "products",
        query: {idcat: id, namecat: name},
      });
    },
  },
  mounted() {
    let id = this.$route.query.id;
    oracle.axios(
        "productCategory/getList",
        {offset_by: 0, limit_by: 1000, order_by: "priority", parent_by: id},
        this.GetCat
    );
  },
};
</script>
<style>
.categories .products {
  background: #fff;
}

.categories .sub-categories {
  min-height: 450px;
  border: 2px solid #7ec352;
  border-radius: 3px;
}

.categories .title-sub-categories {
  color: #fff;
  line-height: 40px;
  padding: 0 10px;
  font-size: 15px;
  background-color: #7ec352;
}

.categories .sub-categories ul {
  display: flex;
  padding: 15px;
  font-size: 12px;
  margin: 0;
  flex-direction: column;
}

.categories .item-sub-categories {
  padding-bottom: 10px;
}

.categories .item-sub-categories span {
  font-size: 14px;
}

.categories .item-sub-categories ul {
  padding-right: 15px;
  padding-left: 15px;
}

.categories .item-sub-categories ul li {
  padding-right: 15px;
  padding-left: 15px;
  line-height: 30px;
  position: relative;
  transition: color ease 0.2s;
}

.categories .item-sub-categories > ul li:before {
  content: "•";
  color: #7ec352;
  position: absolute;
  right: 0;
  font-size: 25px;
  line-height: 0;
  top: 19px;
}

.categories .item-sub-categories ul li a {
  color: #333;
}

.categories .show-products {
  min-height: 400px;
}

.categories .title-show-products-category {
  background-color: #7ec352;
  color: #fff;
  line-height: 45px;
  padding: 0 10px;
  font-size: 15px;
  border-radius: 3px 3px 0 0;
  border: 2px solid #7ec352;
  border-bottom: 0;
  text-align: center !important;
}

.categories .bg-products {
  width: 100%;
  height: 500px;
}

.categories .bg-products img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: #fff;
}

.categories #bg-products {
  padding: 0;
}

.categories .itemproduct_cat-category {
  position: relative;
  text-align: center !important;
  width: 160px;
  margin: auto;
  margin-top: 30px;
}

.categories .img-itemproduct_cat-category {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
}

.categories .img-itemproduct_cat-category img {
  width: 100%;
  height: 100%;
}

.categories .text-itemproduct_cat-category {
  display: flex;
  flex-direction: column;
}

.categories .items-show-cat-category a {
  color: #333;
}

.categories .items-show-cat-category {
  width: 100%;
  display: flex;
}

.categories .text-itemproduct_cat-category h6 {
  font-size: 13px;
  margin-top: 8px;
}

.categories .text-itemproduct_cat-category span {
  font-size: 14px;
  color: #7ec352;
  margin-top: 5px;
}

.categories .add-to-cart_cats {
  position: absolute;
  top: 5px;
  left: 10px;
}

.categories .add-to-cart_cats ul {
  display: flex;
  border: 2px solid #7ec352;
  background: #fff;
  border-radius: 25px;
  justify-content: space-between;
  padding: 0 3px !important;
}

.categories .add-to-cart_cats ul li .v-icon {
  color: #7ec352;
  font-size: 18px !important;
}

.categories .add-to-cart_cats ul li:nth-child(2) {
  padding: 0 5px;
}

.categories .footer-show-products {
  margin: 20px 0;
}

.categories .itemscategory {
  background-color: #a7d38d;
  width: 32px;
  height: 32px;
  border-radius: 100%;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
}

.categories .itemscategory p {
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  margin: 0;
}
</style>
